import { createRequest } from '@shared/services';

interface GetPaymentMethodProps {
    shipping_type: string;
    grand_total_price: number;
}

export async function getPaymentMethod(params: GetPaymentMethodProps) {
    const request = createRequest<GetCartPaymentMethodResponse>({
        url: '/cart/payment-method',
        method: 'GET',
        withAuthorization: true,
        params,
    });

    return request.execute();
}
